<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="headerTemplate"
    [nzActive]="true"
  >
    <ng-template #headerTemplate>
      <div class="header-container">
        <span>
          {{ 'page.training-qualifications.table.collapse.title' | translate }}
        </span>
        @let canCreateTraining =
          can(RoleAction.Create, RolePermissionSubject.QualificationTraining);
        @if (canCreateTraining) {
          <button
            nz-button
            nzType="default"
            (click)="$event.stopPropagation(); addTrainingQualification()"
          >
            <fa-icon [icon]="faPlus" class="mt-1"></fa-icon>
          </button>
        }
      </div>
    </ng-template>
    <ng-container>
      <p class="mb-0">
        {{ 'page.training-qualifications.table.title_digital' | translate }}
        <nz-tag nzColor="success" class="mx-1">
          <span>
            {{
              'page.training-qualifications.table.digital_training' | translate
            }}
          </span>
          <fa-icon [icon]="faBolt" class="ms-1"></fa-icon>
        </nz-tag>
        {{
          'page.training-qualifications.table.title_digital_after' | translate
        }}
      </p>
      <p>
        {{ 'page.training-qualifications.table.sub_title' | translate }}
      </p>

      <nz-table
        #basicTable
        [nzData]="trainingQualificationRows.value"
        [nzShowPagination]="false"
        [nzSize]="'small'"
        [nzTableLayout]="'fixed'"
      >
        <thead>
          <tr>
            <th>
              {{ 'page.training-qualifications.table.provider' | translate }}
            </th>
            <th>
              {{ 'page.training-qualifications.table.course' | translate }}
            </th>
            <th>
              {{
                'page.training-qualifications.table.qualification' | translate
              }}
            </th>
            <th class="delete-column">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (row of trainingQualificationRows.value; track $index) {
            <tr>
              <td>
                <wilson-provider-renderer
                  [providers]="providers"
                  [selectedProvider]="row.provider"
                  [index]="$index"
                  [isEditable]="isRowEditable($index)"
                  (providerChange)="onProviderChange($event, $index)"
                ></wilson-provider-renderer>
              </td>
              <td>
                <wilson-classes-renderer
                  [selectedProvider]="row.provider"
                  [providerClasses]="providerClasses[$index]"
                  [currentSelectedClass]="selectedClasses[$index]"
                  [index]="$index"
                  [isEditable]="isRowEditable($index)"
                  (classChange)="onClassChange($event, $index)"
                ></wilson-classes-renderer>
              </td>
              <td>
                @if (isQualificationsRendererVisible($index)) {
                  <wilson-qualifications-renderer
                    [flowDirection]="flowDirection"
                    [selectedClass]="selectedClasses[$index]"
                    [currentSelectedQualifications]="
                      selectedQualifications[$index]
                    "
                    [index]="$index"
                    [disabled]="isQualificationsDisabled($index)"
                    [isEditable]="isRowEditable($index)"
                    (qualificationsChange)="
                      onQualificationsChange($event, $index)
                    "
                  ></wilson-qualifications-renderer>
                } @else {
                  <wilson-route-renderer
                    [routes]="routes"
                    [routeArray]="
                      $safeNavigationMigration(
                        trainingQualificationRows.value?.[$index]?.routeParts
                      )
                    "
                    [isEditable]="isRowEditable($index)"
                    (startLocationChanged)="onStartLocationChange($event)"
                    (endLocationChanged)="onEndLocationChange($event, $index)"
                  ></wilson-route-renderer>
                }
              </td>
              <td class="delete-column">
                <wilson-delete-renderer
                  [index]="$index"
                  (delete)="onDelete($index)"
                ></wilson-delete-renderer>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </ng-container>
  </nz-collapse-panel>
</nz-collapse>
